// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip__title{display:inherit}.tooltip__inner{box-shadow:0 2px 20px rgba(0,0,0,.15)}", ""]);
// Exports
module.exports = exports;
